export default "__VITE_ASSET__afd0fa10__"